export const en: Record<string, string> = {
  // Home
  'game.title': 'ZOMBIE LAB',
  'home.play': 'PLAY',
  'home.shop': 'SHOP',
  'home.settings': 'SETTINGS',

  // Weapons
  'weapon.pistol': 'Pistol',
  'weapon.shotgun': 'Shotgun',
  'weapon.smg': 'SMG',
  'weapon.rocketLauncher': 'Rocket Launcher',
  'weapon.grenade': 'Grenade',
  'weapon.select': 'Weapon Select',
  'weapon.main': 'Main Weapon',
  'weapon.sub': 'Sub Weapon',
  'weapon.confirm': 'DEPLOY',
  'weapon.level': 'Lv.',
  'weapon.damage': 'Damage',
  'weapon.fireRate': 'Fire Rate',
  'weapon.magazine': 'Magazine',
  'weapon.reload': 'Reload',

  // Stage select
  'stage.select': 'Stage Select',
  'stage.level': 'Level',
  'stage.locked': 'LOCKED',
  'stage.cleared': 'CLEARED',
  'stage.1': 'Laboratory',
  'stage.2': 'City Streets',
  'stage.3': 'Hospital',
  'stage.4': 'Sewers',
  'stage.5': 'Military Base',
  'stage.6': 'Subway',
  'stage.7': 'Factory',
  'stage.8': 'Forest',
  'stage.9': 'Airport',
  'stage.10': 'Final Lab',

  // HUD
  'hud.remaining': 'Zombies Left',
  'hud.reloading': 'Reloading...',

  // Level Clear
  'clear.title': 'LEVEL CLEAR!',
  'clear.kills': 'Kills',
  'clear.coins': 'Coins Earned',
  'clear.time': 'Clear Time',
  'clear.nextLevel': 'Next Level',
  'clear.home': 'Home',

  // Game Over
  'gameover.title': 'GAME OVER',
  'gameover.retry': 'Retry',
  'gameover.home': 'Home',

  // Shop
  'shop.title': 'SHOP',
  'shop.buy': 'BUY',
  'shop.upgrade': 'UPGRADE',
  'shop.purchased': 'OWNED',
  'shop.maxLevel': 'MAX LEVEL',
  'shop.price': 'Price',
  'shop.cost': 'Cost',
  'shop.coins': 'Coins',
  'shop.back': 'Back',
  'shop.tab.weapons': 'Buy Weapons',
  'shop.tab.upgrade': 'Upgrade',
  'shop.notEnough': 'Not enough coins',

  // Settings
  'settings.title': 'SETTINGS',
  'settings.language': 'Language',
  'settings.difficulty': 'Difficulty',
  'settings.back': 'Back',
  'difficulty.easy': 'Easy',
  'difficulty.normal': 'Normal',
  'difficulty.hard': 'Hard',

  // Pause
  'pause.title': 'PAUSED',
  'pause.resume': 'Resume',
  'pause.settings': 'Settings',
  'pause.home': 'Home',

  // General
  'loading': 'Loading...',
  'back': 'Back',
};
